import axios from "axios";
import store from "../store";

const api = axios.create({
    baseURL: `${process.env.VUE_APP_BASE_URL || '/'}index.php`,
    params: {
        auth_key: store.getters.getAuthToken,
    },
    data: {},
});

api.interceptors.request.use((config) => {
    config.params.r = `api/${config.url}`;
    config.url = "/";

    if (config.includeUserId) {
        const userId = store.getters.getUserId;

        if (config.method === "get") {
            config.params.user_id = userId;
        } else {
            config.data.user_id = userId;
        }
    }

    return config;
});

export default api;